<template>
  <base-panel no-padding no-margin>
    <slot />

    <div
      v-for="(item, index) in dependencies"
      :key="item.mod_id"
      :class="{ 'tw-mt-6': index === 0 }"
    >
      <div
        class="tw-flex tw-group tw-items-center game-tile-background-color-hover"
        :class="{
          'tw-opacity-70 tw-pointer-events-none tw-cursor-not-allowed':
            item.hidden,
        }"
      >
        <base-link
          :link-primary="false"
          :to="
            item.hidden
              ? ''
              : {
                  name: MOD_VIEW_ROUTE,
                  params: { mod: item.name_id },
                }
          "
          class="tw-flex tw-justify-between tw-w-full tw-h-24"
        >
          <div class="tw-flex tw-justify-between tw-items-center">
            <img
              class="tw-object-cover tw-size-10 md:tw-h-14 md:tw-w-24"
              alt="Image thumbnail"
              :src="
                item.hidden ? PLACEHOLDER_CARD_IMAGE : item.logo[CARD_IMAGE_KEY]
              "
            />
            <div class="tw-flex tw-flex-col tw-px-2">
              <span
                v-decode="item.name"
                class="tw-font-bold mod-util-truncate-two-lines"
              />
              <mod-card-footer
                v-if="!item.hidden"
                browse-id="mod-dependencies"
                dependency
                :stats="item.stats"
                :modfile="item.modfile"
              />
            </div>
          </div>
        </base-link>
        <subscribe-button
          v-if="!item.hidden && Settings.allowSubscribing"
          class="tw-w-32"
          :full-width="false"
          :custom-class="Classes.DEPENDENCY_SUBSCRIBE_BUTTON"
          :game="game"
          is-browse
          :mod="{
            ...item,
            game_id: game.id,
            game_name_id: game.name_id,
          }"
        />
      </div>
      <div
        v-if="index < dependencies.length - 1"
        class="tw-w-full tw-border-t tw-border-primary"
      />
    </div>
  </base-panel>
</template>

<script>
import SubscribeButton from '@components/Mod/SubscribeButton.vue'
import { PLACEHOLDER_CARD_IMAGE, CARD_IMAGE_KEY } from '@config'
import ModCardFooter from '@components/List/ModCardFooter.vue'
import { MOD_VIEW_ROUTE } from '@config/routeNames.js'
import { useResourceValue } from '@composables'
import Classes from '@shared/js/config/css.js'
import { Settings } from '@config/game.js'
export default {
  components: {
    SubscribeButton,
    ModCardFooter,
  },
  props: {
    game: {
      type: Object,
      required: true,
    },
    isCollection: {
      type: Boolean,
      default: false,
    },
    panelLoading: {
      type: Boolean,
      default: false,
    },
    dependencies: {
      type: Object,
      default: null,
    },
  },
  setup() {
    const { ugcName } = useResourceValue()

    return {
      PLACEHOLDER_CARD_IMAGE,
      CARD_IMAGE_KEY,
      MOD_VIEW_ROUTE,
      Settings,
      Classes,
      ugcName,
    }
  },
}
</script>
